import React from 'react';

import PropTypes from 'prop-types';

import { TabsContent } from '@/components/ui/tabs';

const TabsView = ({ config }) =>
  config.map(({ component: Component, value }) => (
    <TabsContent key={value} value={value}>
      <Component />
    </TabsContent>
  ));

TabsView.propTypes = {
  config: PropTypes.arrayOf(
    PropTypes.shape({
      component: PropTypes.elementType.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TabsView;
